@if (dashboard.attendanceMode === 'daily' && dashboard.attendanceDate) {
  <section class="day-toolbar" aria-label="開催日の切り替え">
    <div><h2>開催日ごとの出欠</h2></div>
    @if (dashboard.attendanceDates.length > 1) {
      <label>表示する開催日<select [ngModel]="dashboard.attendanceDate" (ngModelChange)="dateChange.emit($event)" [disabled]="showSpinner || reasonOpen || finalizeOpen || adding">
        @for (day of dashboard.attendanceDates; track day) { <option [value]="day">{{ dayLabel(day) }}</option> }
      </select></label>
    } @else { <strong>{{ dayLabel(dashboard.attendanceDate) }}</strong> }
  </section>
  @if (!dashboard.canUpdateActual && !editingLocked && dashboard.selectedCheckinStart) {
    <p class="hint">この日の出席受付は {{ historyTime(dashboard.selectedCheckinStart) }} からです。</p>
  }
} @else if (dashboard.attendanceDates.length > 1) {
  <p class="schedule-notice">この企画は旧方式で、出席を企画全体で記録しています。設定を保存すると日別方式へ切り替わります。</p>
}
<section class="summary" aria-label="当日実績の集計">
  <div><span>対象者</span><strong>{{ dashboard.summary.total }}人</strong></div>
  <div><span>実出席</span><strong>{{ dashboard.summary.attended }}人</strong></div>
  <div><span>欠席</span><strong>{{ dashboard.summary.absent }}人</strong></div>
  <div><span>未登録</span><strong>{{ dashboard.summary.notCheckedIn }}人</strong></div>
  <div><span>参加率</span><strong>{{ dashboard.summary.participationRate }}%</strong></div>
</section>
@if (dashboard.quorum; as quorum) {
  <section class="quorum-status" [class.met]="quorum.met" aria-label="会議成立状況">
    <div><span class="quorum-label">会議成立状況</span><strong>{{ quorum.met ? '成立' : '未成立' }}</strong><p>{{ quorum.met ? '成立に必要な人数に達しています' : 'あと ' + remaining(quorum.attended,quorum.required) + '人で成立' }}</p></div>
    <div class="quorum-numbers"><span>成立対象の実出席<strong>{{ quorum.attended }}<small>人</small></strong></span><span>成立に必要<strong>{{ quorum.required }}<small>人</small></strong></span><span>会議定数<strong>{{ quorum.total }}<small>人</small></strong></span></div>
  </section>
}
<p class="planned-summary">事前回答：出席予定 {{ dashboard.plannedSummary.attending }}人 ／ 欠席予定 {{ dashboard.plannedSummary.absent }}人 ／ 未回答 {{ dashboard.plannedSummary.unanswered }}人</p>
<p class="hint">表示は{{ refreshIntervalSeconds }}秒ごとに更新します。<button type="button" [disabled]="showSpinner || refreshInProgress || finalizationBusy" (click)="refresh.emit()">今すぐ更新</button></p>

<p class="hint">事前の「出席予定」と、当日の「実出席」は別の記録です。参加率は対象者に対する実出席の割合です。未登録を自動で欠席にはしません。</p>
@if (dashboard.organizationSummary.length) {
  <details class="organization-breakdown">
    <summary>所属別の参加状況を見る</summary>
    <div class="table-wrap"><table><thead><tr><th>所属</th><th>対象者</th><th>実出席</th><th>欠席</th><th>未登録</th><th>参加率</th></tr></thead><tbody>
    @for (item of dashboard.organizationSummary; track item.organizationId) {
      <tr><td>{{ item.organizationPath }}</td><td>{{ item.total }}人</td><td>{{ item.attended }}人</td><td>{{ item.absent }}人</td><td>{{ item.notCheckedIn }}人</td><td>{{ item.participationRate }}%</td></tr>
    }
    </tbody></table></div>
  </details>
}
